import { CFDStatus } from 'features/cfd/state/cfdAtoms';
import { ObjectiveKey } from 'shared/domain/objectivePresets';

export const getCFDStatusLabel = (statusCode: number): string => {
  switch (statusCode) {
    case 200:
      return 'complete';
    case 201:
      return 'running';
    case 400:
      return 'CFD failed';
    case 404:
      return 'request failed';
    case 500:
      return 'server error';
    default:
      return 'N/A';
  }
};

export const getCFDObjectiveStatusLabel = (
  cfd: Pick<CFDStatus, 'status' | 'status_code'>,
  key: ObjectiveKey
): string => {
  const status = cfd.status?.[key]?.trim();
  return status || getCFDStatusLabel(cfd.status_code);
};
